import React, { useState, useEffect, useMemo } from "react";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../../Student/Reusablecomponents/Loading";
import { format } from "date-fns";
import { RiFileExcel2Fill } from "react-icons/ri";
import { DownloadExcel } from "../../ReusableComponents/CommonFunctions";
import { GetQBAdminUsers } from "../../ReusableComponents/NCLAdminDropdowns";
import axiosInstance from "../../ReusableComponents/Axios";
import notify from "../../ReusableComponents/ToastifyAlerts";
import Allusers from "./AllUsers";
const QuestionStatusTrack = () => {
  const [subjectId, setSubjectId] = useState(1);
  const [Load, SetLoad] = useState(false);
  const [QuestionTrack, SetQuestionTrack] = useState([]);
  const [questionType, setQuestionType] = useState("1");
  const [PweekDates, SetPweekDates] = useState();
  const [PageCount, SetPageCount] = useState(10);
  const [CPage, SetCPage] = useState(1);
  const subjects = {
    1: "Mathematics",
    2: "Science",
    3: "English",
  };
  const [SelectDateType, SetSelectDateType] = useState("CM");
  const [StartDate, SetStartDate] = useState("");
  const [EndDate, SetEndDate] = useState("");
  const [SelectUsers, SetSelectUsers] = useState([]);
  const OverallQuestionStatusTrack = async (PageNo) => {
    SetQuestionTrack([]);
    if (SelectUsers.length <= 10 && SelectUsers.length > 0) {
      if (SelectDateType === "CD" && StartDate && !EndDate) {
        notify("Please select End date", "warning");
      } else {
        SetCPage(PageNo);
        SetLoad(true);
        try {
          const response = await axiosInstance.get(
            `/NCLAdmin/GetOverallQuestionsTrack?SubjectId=${subjectId}&pageno=1&pagesize=${PageCount}&pagination=0&DateFilter=${SelectDateType}&UserId=${SelectUsers?.map(item => item.value).join(",")}&StartDate=${StartDate}&EndDate=${EndDate} `,
          );
          SetLoad(false);
          SetQuestionTrack(response.data);
        } catch (error) {
          console.error("Error fetching Questions data:", error);
          return [];
        }
      }
    }
    else {
      alert(SelectUsers.length > 10 ? "You can select maximum 10 users" : "Please select at least one user");
    }
  };
  useEffect(() => {
    if (SelectUsers.length >= 1 && SelectDateType !== "SD" && SelectDateType !== "CD" && questionType == "1") {
      OverallQuestionStatusTrack();
    }
    else if (questionType == "0") {
      fetchWeeklyTrack(subjectId);
    }
  }, [questionType, SelectDateType]);
  const fetchWeeklyTrack = async (SID) => {
    SetQuestionTrack([]);
    SetLoad((prev) => !prev);
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetWeeklyQuestionsTrack?SubjectId=${SID}&pageno=1&pagesize=10&pagination=0`);
      SetQuestionTrack(res.data);
    }
    catch (error) {
      console.error("Error fetching weekly track data:", error);
    }
    finally { SetLoad((prev) => !prev); }
  }

  const OverAllColumns = [
    { name: "Grade", selector: "grade", sortable: true, },
    { name: "CBSE / SCERT Chapter No", selector: "chapterNo", sortable: false, cell: (row) => (row.chapterNo === 0 ? "" : row.chapterNo), },
    ...(subjectId === 1
      ? [
        { name: "Content", selector: "content", sortable: true, },
      ]
      : []),
    ...(subjectId === 3 ? [{ name: "Book", selector: "book", sortable: true }] : []),
    ...(subjectId !== 3 ? [{ name: "Topic", selector: "topic", sortable: true, },
    { name: "Subtopic", selector: "subTopic", sortable: true, },] : []),
    { name: "Learning Outcome", selector: "learningOutcome", sortable: true },
    ...(subjectId !== 3 ? [
      { name: "Sub-Learning Outcome", selector: "subLO", sortable: true, },
      { name: "NCERT Learning Outcome", selector: "ncertlo", sortable: true, },
    ] : []),
    { name: "Source", selector: "source", sortable: true, },
    { name: "ScenarioID", selector: "scenarioID", sortable: true, cell: (row) => (row.scenarioID === 0 ? "" : row.scenarioID), },
    { name: "QuestionID", selector: "questionID", sortable: false, },
    { name: "QB creator name", selector: "qbCreator", sortable: true },
    { name: "Created Date", selector: "createdDate", sortable: true, cell: (row) => row.createdDate ? format(new Date(row.createdDate), "dd-MM-yyyy") : "", },
    { name: "QB Status", selector: "qcStatus", sortable: true },
    { name: "QC done by", selector: "qcDoneBy", sortable: true, },

    { name: "QC Completion Date", selector: "qcCompletionDate", sortable: true, cell: (row) => row.qcCompletionDate ? format(new Date(row.qcCompletionDate), "dd-MM-yyyy") : "", },
    ...(subjectId === 1
      ? [
        { name: "Cloned/Original", selector: "clonedorOriginal", sortable: true, },
      ]
      : []),

    { name: "Alignment of Items with Standard", selector: "alignmentofItemswithStandard", sortable: true, },
    { name: "Stem of Question", selector: "stemofquestion", sortable: true, },
    { name: "MCQs Options", selector: "mcQsOptions", sortable: true, },
    { name: "Item Bias and Sensitivity Issues", selector: "itemBiasandSensitivityIssues", sortable: true, },
    { name: "Image Quality and Relevance", selector: "imageQualityandRelevance", sortable: true, },
    { name: "Grammar and Layout", selector: "grammarandLayout", sortable: true, },

    ...(subjectId !== 3 ? [
      { name: "Translation date (Using AI)", selector: "createdDate", sortable: true, cell: (row) => row.createdDate ? format(new Date(row.createdDate), "dd-MM-yyyy") : "", },
      { name: "QC Status of translated question", selector: "qcTranslationStatus", sortable: true },
      { name: "QC Completion Date for translated question", selector: "qcTranslationCompletionDate", sortable: true, cell: (row) => row.qcTranslationCompletionDate ? format(new Date(row.qcTranslationCompletionDate), "dd-MM-yyyy") : "", },
      { name: "QC Translation done by", selector: "qcTranslationDoneBy", sortable: true, },
      { name: "Type of Issue", selector: "typeOfIssue", sortable: true, },
    ] : []),


  ];

  useEffect(() => {
    const now = new Date();
    const dayInWeek = now.getDay();

    const previousMonday = new Date(now.setDate(now.getDate() - dayInWeek - 6));
    const previousSunday = new Date(previousMonday);
    previousSunday.setDate(previousMonday.getDate() + 6);
    SetPweekDates(
      `${format(previousMonday, "dd/MMM/yyyy")} - ${format(
        previousSunday,
        "dd/MMM/yyyy"
      )}`
    );

  }, []);

  const DownloadOverallQuestionsTrack = async () => {

    if (SelectDateType === "SD" || SelectDateType === "CD") {
      if (!StartDate) {
        notify(`Please select ${SelectDateType === "CD" ? "Start" : ""} date`, "warning");
        return;
      }
      if (!EndDate && SelectDateType !== "SD") {
        {
          notify(`Please select End date`, "warning");
          return;
        }
      }
    }
    if ((QuestionTrack.length <= 1 && QuestionTrack?.[0]?.questionID === 0) || QuestionTrack.length === 0) {
      notify("No data available to download", "info");
      return;
    }

    const SUsers = SelectUsers?.map(item => item.Name);
    const FOrmatedData = QuestionTrack.reduce((acc, item, index) => {
      //   if (!acc[item?.qbCreator]) {
      //     acc[item?.qbCreator] = [];
      //   }
      //   acc[item?.qbCreator].push(item);
      //   return acc;
      // }, {});
      SUsers.forEach(user => {
        // if (
        //   user === item.qbCreator ||
        //   user === item.qcDoneBy ||
        //   user === item.qcTranslationDoneBy
        // ) {
        if (!acc[user]) {
          acc[user] = [];
        }
        if (
          user === item.qbCreator ||
          user === item.qcDoneBy ||
          user === item.qcTranslationDoneBy
        ) {
          acc[user].push({
            ...item,
            matchedRole: [
              user === item.qbCreator && "QB Creator",
              user === item.qcDoneBy && "QC Done By",
              user === item.qcTranslationDoneBy && "QC Translation Done By"
            ].filter(Boolean).join(", ")
          });
        }
      });
      return acc;
    }, {});
    const filterdata = Object.fromEntries(
      Object.entries(FOrmatedData).filter(([key, value]) => value.length !== 0) );
    const XL = Object.keys(filterdata).map(key => ({
      sheetName: key,
      details: FOrmatedData[key].map((item, index) => ({
        SNo: index + 1,
        Grade: item.grade,
        "CBSE / SCERT Chapter No": item.chapterNo === 0 ? "" : item.chapterNo,
        ...(subjectId === 1 && {
          "Content": item?.content
        }),
        ...(subjectId === 3 && { Book: item.book }),
        ...(subjectId !== 3 && {
          "Topic": item.topic,
          "Subtopic": item?.subTopic,
        }),
        "Learning Outcome": item.learningOutcome,
        ...(subjectId !== 3 && {
          "Sub-Learning Outcome": item.subLO,
          "NCERT Learning Outcome": item?.ncertlo,
        }),
        "Source": item.source,
        ScenarioID: item.scenarioID === 0 ? "" : item.scenarioID,
        "QuestionID	": item.questionID,
        "QB creator name": item.qbCreator,
        "Created Date": item.createdDate,
        "QB Status": item.qcStatus,
        "QC done by": item?.qcDoneBy,
        "QC Completion Date": item.qcCompletionDate,
        ...(subjectId === 1 && {
          "Cloned/Original": item.clonedorOriginal,
        }),
        "Alignment of Items with Standard": item.alignmentofItemswithStandard,
        "Stem of Question": item?.stemofquestion,
        "MCQs Options": item?.mcQsOptions,
        "Item Bias and Sensitivity Issues": item?.itemBiasandSensitivityIssues,
        "Image Quality and Relevance": item?.imageQualityandRelevance,
        "Grammar and Layout": item?.grammarandLayout,

        ...(subjectId !== 3 && {
          "Translation date (Using AI)": item.createdDate ? format(new Date(item.createdDate), "dd-MM-yyyy") : "",
          "QC Status of translated question": item.qcTranslationStatus,
          "QC Completion Date for translated question": item.qcTranslationCompletionDate ? format(new Date(item.qcTranslationCompletionDate), "dd-MM-yyyy") : "",
          "QC Translation done by": item?.qcTranslationDoneBy,
          "Type of Issue": item?.typeOfIssue,
        }),

      }))
    }));
    const subjectName = subjects[subjectId];
    DownloadExcel(
      XL,
      `Master_Content_Report_${subjectName}_${SelectDateType === "SD" ? QuestionTrack?.[0]?.startEndDate?.split(" ")[0] : QuestionTrack?.[0]?.startEndDate?.replaceAll("/", "-")?.replaceAll(" ", "_")}`,
      true,
      `Overall Question Status Track (${subjectName})`,
      `Master_Content_Report_${subjectName}_${SelectDateType === "SD" ? QuestionTrack?.[0]?.startEndDate?.split(" ")[0] : QuestionTrack?.[0]?.startEndDate?.replaceAll("/", "-")?.replaceAll(" ", "_")}`,
      true
    );
  };
  const DownloadWeeklyTrack = () => {
    if (QuestionTrack.length === 0) {
      notify("No data available to download", "info");
      return;
    }
    const sanitizedPweekDates = PweekDates.replace(/[\/:*?"<>|\\[\]]/g, "_");
    const subjectName = subjects[subjectId];
    const XL = QuestionTrack?.map((item, index) => {
      return {
        SNo: index + 1,
        Grade: item.grade,
        "CBSE / SCERT Chapter No": item.chapterNo === 0 ? "" : item.chapterNo,
        ...(subjectId === 1 && {
          "Content": item?.content
        }),
        ...(subjectId === 3 && { Book: item.book }),
        ...(subjectId !== 3 && {
          "Topic": item.topic,
          "Subtopic": item?.subTopic,
        }),
        "Learning Outcome": item.learningOutcome,
        ...(subjectId !== 3 && {
          "Sub-Learning Outcome": item.subLO,
          "NCERT Learning Outcome": item?.ncertlo,
        }),
        "Source": item.source,
        ScenarioID: item.scenarioID === 0 ? "" : item.scenarioID,
        "QuestionID	": item.questionID,
        "QB creator name": item.qbCreator,
        "Created Date": item.createdDate,
        "QB Status": item.qcStatus,
        "QC done by": item?.qcDoneBy,
        "QC Completion Date": item.qcCompletionDate,
        ...(subjectId === 1 && {
          "Cloned/Original": item.clonedorOriginal,
        }),
        "Alignment of Items with Standard": item.alignmentofItemswithStandard,
        "Stem of Question": item?.stemofquestion,
        "MCQs Options": item?.mcQsOptions,
        "Item Bias and Sensitivity Issues": item?.itemBiasandSensitivityIssues,
        "Image Quality and Relevance": item?.imageQualityandRelevance,
        "Grammar and Layout": item?.grammarandLayout,

        ...(subjectId !== 3 && {
          "Translation date (Using AI)": item.createdDate ? format(new Date(item.createdDate), "dd-MM-yyyy") : "",
          "QC Status of translated question": item.qcTranslationStatus,
          "QC Completion Date for translated question": item.qcTranslationCompletionDate ? format(new Date(item.qcTranslationCompletionDate), "dd-MM-yyyy") : "",
          "QC Translation done by": item?.qcTranslationDoneBy,
          "Type of Issue": item?.typeOfIssue,
        }),

      };
    });
    DownloadExcel(
      XL,
      `Weekly Question Track (${sanitizedPweekDates}) - ${subjectName}`,
      false,
      `Weekly Question Track (${sanitizedPweekDates}) - ${subjectName}`,
      `Weekly Question Track (${sanitizedPweekDates}) - ${subjectName}`,
      true
    );
  };
  const SDT = [
    { name: "By Date", value: "SD", },
    { name: "Current Week", value: "CW", },
    { name: "Previous Week", value: "PW", },
    { name: "Current Month", value: "CM", },
    { name: "Previous Month", value: "PM", },
    { name: "Date Range", value: "CD", },
  ];
  const StoreQBUsers = (e, r) => {
    SetSelectUsers(e);
    if (e.length === 10) {
      notify("A maximum of 10 users can be selected.", "warning");
    }
  }
  useMemo(() => {
    if (SelectUsers.length === 1) {
      OverallQuestionStatusTrack();
    }
  }, [SelectUsers]);
  const CLearQBUsers = () => {
    SetSelectUsers([]);
    // SetSelectUsers([SelectUsers[0]]);
  }
  const OnChangeDatefilters = (e) => {
    SetStartDate("");
    SetEndDate("");
    SetSelectDateType(e);
    SetQuestionTrack([]);
  }
  const Division = [
    { Name: "By QB Users", value: 1 },
    { Name: "Weekly", value: 0 },
    { Name: "Overall", value: 2 },
  ];
  const [AllUsersData, SetAllUsersData] = useState([]);
  const DAllUsers = () => {
    SetLoad(true);
    if (AllUsersData.length === 0) {
      notify("No data available to download", "info");
      return;
    }
    setTimeout(() => {
      const subjectName = subjects[subjectId];
      const XL = AllUsersData?.map((item, index) => {
        return {
          SNo: index + 1,
          Grade: item.grade,
          "CBSE / SCERT Chapter No": item.chapterNo === 0 ? "" : item.chapterNo,
          ...(subjectId === 1 && {
            "Content": item?.content
          }),
          ...(subjectId === 3 && { Book: item.book }),
          ...(subjectId !== 3 && {
            "Topic": item.topic,
            "Subtopic": item?.subTopic,
          }),
          "Learning Outcome": item.learningOutcome,
          ...(subjectId !== 3 && {
            "Sub-Learning Outcome": item.subLO,
            "NCERT Learning Outcome": item?.ncertlo,
          }),
          "Source": item.source,
          ScenarioID: item.scenarioID === 0 ? "" : item.scenarioID,
          "QuestionID	": item.questionID,
          "QB creator name": item.qbCreator,
          "Created Date": item.createdDate,
          "QB Status": item.qcStatus,
          "QC done by": item?.qcDoneBy,
          "QC Completion Date": item.qcCompletionDate,
          ...(subjectId === 1 && {
            "Cloned/Original": item.clonedorOriginal,
          }),
          "Alignment of Items with Standard": item.alignmentofItemswithStandard,
          "Stem of Question": item?.stemofquestion,
          "MCQs Options": item?.mcQsOptions,
          "Item Bias and Sensitivity Issues": item?.itemBiasandSensitivityIssues,
          "Image Quality and Relevance": item?.imageQualityandRelevance,
          "Grammar and Layout": item?.grammarandLayout,

          ...(subjectId !== 3 && {
            "Translation date (Using AI)": item.createdDate ? format(new Date(item.createdDate), "dd-MM-yyyy") : "",
            "QC Status of translated question": item.qcTranslationStatus,
            "QC Completion Date for translated question": item.qcTranslationCompletionDate ? format(new Date(item.qcTranslationCompletionDate), "dd-MM-yyyy") : "",
            "QC Translation done by": item?.qcTranslationDoneBy,
            "Type of Issue": item?.typeOfIssue,
          }),
        };
      });
      DownloadExcel( XL, `All Users Question Track - ${subjectName}`, false,
        `All Users Question Track - ${subjectName}`, `All Users Question Track - ${subjectName}`, true );
      SetLoad(false);
    }, 0);
  }
  return (
    <>
      <div className="dflex alignitems justify-content-between w-100 mt-1 p-2">
        <div className="dflex alignitems gap-4">
          <h2 className="SubHeading mb-0"> Question Status Track {questionType == "0" && `(${PweekDates})`} </h2>
        </div>

        <div className="dflex alignitems gap-2">
          <div className="ExportExcel dflex alignitems CPointer"
            onClick={() =>
              questionType == "0"
                ? DownloadWeeklyTrack()
                : questionType == 2
                  ? DAllUsers()
                  : DownloadOverallQuestionsTrack()
            }
            title="Export Excel"
          >
            <RiFileExcel2Fill className="me-2" />
          </div>

          <select className="NCLDropdown" value={subjectId}
            onChange={(e) => { setSubjectId(Number(e.target.value)); if (questionType == "0") { fetchWeeklyTrack(Number(e.target.value)) } }}
          >
            {Object.entries(subjects).map(([id, name]) => (<option key={id} value={id}> {name} </option>))}
          </select>
        </div>
      </div>
      <div className="dflex gap-3">
        {Division.map((item) => (
          <div className="dflex alignitems ">
            <input
              type="radio"
              name="questionStatus1"
              value={item.value}
              checked={parseInt(questionType) == item.value}
              onChange={() => setQuestionType(item.value)}
            />
            <label className="form-check-label ms-1" htmlFor={item.value}>
              {item.Name}
            </label>
          </div>
        ))}</div>
      {questionType === 2 ? <Allusers subjectId={subjectId} StoreAll={SetAllUsersData} /> : <>

        {questionType != "0" &&
          <div className="dflex alignitems flexd-column InputFIlters mt-3">
            <label>Filters</label>
            <div className="dflex w-100 gap-3" style={{ alignItems: "flex-end" }}>
              <GetQBAdminUsers selected={SelectUsers} onChange={(e, r) => StoreQBUsers(e, r)} Storevalue={SetSelectUsers} SUBId={subjectId} />
              {/* CallApi={OverallQuestionStatusTrack} */}
              {(SelectDateType !== "SD" && SelectDateType !== "CD") && <button className="Buttons" style={{ padding: "10px" }} onClick={() => OverallQuestionStatusTrack()}>Go</button>}
              <button className="Buttons" style={{ padding: "10px" }} onClick={() => CLearQBUsers()} >Clear</button></div>
            <div className="dflex gap-4 alignitems">
              {SDT.map((item) =>
                <div className="dflex gap-1 alignitems">
                  <input type="radio" name="dateFilter" value={item?.value} checked={SelectDateType === item?.value} onClick={() => { OnChangeDatefilters(item?.value); }} /> {item?.name}</div>)}</div>

            {(SelectDateType === "SD" || SelectDateType === "CD") &&
              <div className="dflex gap-3 alignitems ">
                <div className="dflex gap-1">
                  <div className="DropdownHeader"> {SelectDateType === "SD" ? "Select" : "Start"} Date :</div>
                  <input type="date" className="NCLDropdown" value={StartDate} onChange={(e) => SetStartDate(e.target.value)} max={new Date().toISOString().split("T")[0]} />
                </div>
                {SelectDateType !== "SD" &&
                  <div className="dflex gap-1">
                    <div className="DropdownHeader"> End Date : </div>

                    <input type="date" className="NCLDropdown" value={EndDate} onChange={(e) => SetEndDate(e.target.value)} min={StartDate} max={new Date().toISOString().split("T")[0]}
                      disabled={!StartDate} />
                  </div>
                }
                <button className="Buttons" onClick={() => OverallQuestionStatusTrack()}>Go</button>
              </div>}
            {QuestionTrack?.length > 0 && `You have selected ${SDT.find(item => item.value === SelectDateType)?.name} : ${SelectDateType === "SD" ? QuestionTrack?.[0]?.startEndDate?.split(" ")[0] : QuestionTrack?.[0]?.startEndDate}   and count : ${QuestionTrack?.[0]?.questionID <= 0 ? 0 : QuestionTrack?.length}`}
          </div>}
        <DataTable className="NCLDataTable Card mt-3"
          data={QuestionTrack?.[0]?.questionID <= 0 ? [] : QuestionTrack} columns={OverAllColumns}
          // columns={questionType !== "0" ? OverAllColumns : Columns}
          CountPage={SetPageCount} Dropdownvalues={["10", "25", "50", "100"]}
          ShowPagination={true} ShowPagecount={true} tableMinWidth="94vw" />
        {/* </div> */}</>}
      {Load && <Loading />}
    </>
  );
};
export default QuestionStatusTrack;
